"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const jsx_runtime_1 = require("react/jsx-runtime");

const Dropdown_1 = __importDefault(require("../Icons/Dropdown"));

const hooks_1 = require("../../hooks");

const react_1 = require("react");

const styles_1 = require("./styles");

const Accordion = (0, react_1.forwardRef)((props, ref) => {
  const {
    summary,
    children,
    defaultExpanded,
    onChange,
    expanded: propsExpanded,
    stylesOverride
  } = props;
  const [expanded, setExpanded] = (0, react_1.useState)(!!defaultExpanded);
  const [contentHeight, setContentHeight] = (0, react_1.useState)(0);
  const contentRef = (0, react_1.useRef)(null);
  const {
    borderBoxSize,
    contentRect
  } = (0, hooks_1.useResizeObserver)(contentRef);

  const onToggle = () => {
    setExpanded(!expanded);
    onChange === null || onChange === void 0 ? void 0 : onChange(!expanded);
  };

  (0, react_1.useEffect)(() => {
    // rectHeight is a fallback for Safari, since it does not support borderBoxSize/contentBoxSize
    const rectHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) + 12 + 25;
    const newHeight = (borderBoxSize === null || borderBoxSize === void 0 ? void 0 : borderBoxSize.blockSize) || rectHeight || 0;

    if (newHeight !== contentHeight) {
      setContentHeight(newHeight);
    }
  }, [borderBoxSize, contentRect]);
  (0, react_1.useEffect)(() => {
    if (typeof propsExpanded === 'boolean') {
      setExpanded(!!propsExpanded);
    }
  }, [propsExpanded]);
  return (0, jsx_runtime_1.jsxs)(styles_1.AccordionWrapper, Object.assign({
    ref: ref,
    stylesOverride: stylesOverride
  }, {
    children: [(0, jsx_runtime_1.jsxs)(styles_1.AccordionSummary, Object.assign({
      expanded: expanded,
      onClick: onToggle
    }, {
      children: [summary, (0, jsx_runtime_1.jsx)(styles_1.AccordionToggle, Object.assign({
        expanded: expanded
      }, {
        children: (0, jsx_runtime_1.jsx)(Dropdown_1.default, {}, void 0)
      }), void 0)]
    }), void 0), (0, jsx_runtime_1.jsx)(styles_1.AccordionDetails, Object.assign({
      expanded: expanded,
      contentHeight: contentHeight
    }, {
      children: (0, jsx_runtime_1.jsx)(styles_1.Content, Object.assign({
        ref: contentRef
      }, {
        children: children
      }), void 0)
    }), void 0)]
  }), void 0);
});
exports.default = Accordion;